























































import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component({})
export default class GalleryModal extends Vue {
    public readonly SCROLL_STEP: number = 40;

    @Action("fetchAlbums")
    public fetchAlbums: any;

    @Action("setCurrentMediaIndex")
    public setCurrentMediaIndex: any;

    @Action("closeGallery")
    public closeGallery: any;

    @State("mediasToShow")
    public mediaCollection: any;

    @State("currentMediaIndex")
    public currentMediaIndex: number;

    @State("isGalleryOpen")
    public isGalleryOpen: boolean;

    public topPosition: number = 0;

    public mounted() : void {
            this.topPosition = (document.querySelector("html") as HTMLElement).scrollTop;
    }
    public getImageSource(src: string) {
        return process.env.VUE_APP_DOMAIN + src;
    }

    public handleImageChange(index: number) : void {
        this.setCurrentMediaIndex(index);
    }

    public getCurrentMediaSource() : string {
        return process.env.VUE_APP_DOMAIN + this.mediaCollection[this.currentMediaIndex].src;
    }

    public getPreviousImage() : void {
        if (this.currentMediaIndex === 0) {
            this.setCurrentMediaIndex(this.mediaCollection.length - 1);
        } else {
            this.setCurrentMediaIndex(this.currentMediaIndex - 1);
        }
    }

    public getNextImage() : void {
        if (this.currentMediaIndex === this.mediaCollection.length - 1) {
            this.setCurrentMediaIndex(0);
        } else {
            this.setCurrentMediaIndex(this.currentMediaIndex + 1);
        }
    }

    public isImage() : boolean {
        return this.mediaCollection[this.currentMediaIndex].type.includes("image");
    }

    private scrollThumbnailBack() : void {
        const container = document.querySelector(".thumbnail-container") as HTMLElement;
        const backButton = document.querySelector(".left-slider") as HTMLElement;
        const forwardButton = document.querySelector(".right-slider") as HTMLElement;

        if (!container) {
            return;
        }

        if (forwardButton && forwardButton.classList.contains("hidden")) {
            forwardButton.classList.remove("hidden");
        }

        if (container.scrollLeft < this.SCROLL_STEP) {
            container.scrollLeft = 0;
            if (backButton && !backButton.classList.contains("hidden")) {
                backButton.classList.add("hidden");
            }
            return;
        }

        container.scrollLeft -= this.SCROLL_STEP;
    }

    private scrollThumbnailForward() : void {
        const container = document.querySelector(".thumbnail-container") as HTMLElement;
        const backButton = document.querySelector(".left-slider") as HTMLElement;
        const forwardButton = document.querySelector(".right-slider") as HTMLElement;

        if (!container) {
            return;
        }

        if (backButton && backButton.classList.contains("hidden")) {
            backButton.classList.remove("hidden");
        }

        if (container.scrollLeft + this.SCROLL_STEP + container.offsetWidth >= container.scrollWidth) {
            container.scrollLeft = container.scrollWidth - container.offsetWidth;
            if (forwardButton && !forwardButton.classList.contains("hidden")) {
                forwardButton.classList.add("hidden");
            }
            return;
        }

        container.scrollLeft += this.SCROLL_STEP;
    }

    @Watch("isGalleryOpen")
    private toggleGalleryModal() {
        const modal = document.querySelector(".media-modal") as HTMLElement;
        const container = document.querySelector(".thumbnail-container") as HTMLElement;
        const backButton = document.querySelector(".left-slider") as HTMLElement;
        const forwardButton = document.querySelector(".right-slider") as HTMLElement;

        if (!modal || !container || !backButton || !forwardButton) {
            return;
        }
        if (this.isGalleryOpen) {
            backButton && backButton.classList.add("hidden");
            if (container && container.scrollWidth > container.offsetWidth) {
                forwardButton && forwardButton.classList.add("hidden");
            } else {
                forwardButton && forwardButton.classList.remove("hidden");
            }
        } else {
            modal.style.zIndex = "-1";
        }
    }
}

